import React from 'react'
import NavBarTop from '../../NavBar_Top/NavBar_Top';
import Carrinho from '../../Carrinho/Carrinho';
import Rodape from '../../Rodape/Rodape';
import Box from '@mui/material/Box';


function MeuCarrinho(props) {
  return (    
    <div>      
      <NavBarTop />   
      <Box sx={{ marginBottom: 3 }} >
        <Carrinho props={props} />
      </Box>
      <Rodape />
    </div>
  )
}
export default MeuCarrinho